import { trackEvent, EVENTS } from "../analytics";

export default function Contact() {
  const trackLinkClick = (linkType, linkText) => {
    trackEvent(EVENTS.CONTACT_LINK_CLICK, {
      link_type: linkType,
      link_text: linkText,
      section_id: 'contact',
    });
  };
  return (
    <div
      className="bg-dark container-fluid"
      style={{ 
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0
      }}
    >
      <div style={{ maxWidth: "1000px", width: "100%", padding: "3rem", textAlign: "center" }}>
        <div className="text-white">
          <h1>
            FOR INQUIRIES &amp; QUESTIONS:
            <br />
          </h1>
          <p>
            <i className="fa fa-paper-plane fa-fw"></i>
            <a
              href="mailto:myke@myked.com"
              data-analytics-id="contact_email"
              data-analytics-handled="true"
              onClick={() => trackLinkClick('email', 'myke@myked.com')}
            >
              myke@myked.com
            </a>
            <br />
            <i className="fa fa-linkedin-square fa-fw"></i>
            <a
              href="https://www.linkedin.com/in/mykedixon"
              data-analytics-id="contact_linkedin"
              data-analytics-handled="true"
              onClick={() => trackLinkClick('linkedin', 'linkedin.com/in/mykedixon')}
            >
              linkedin.com/in/mykedixon
            </a>
            <br />
            <i className="fa  fa-video-camera fa-fw"></i>

            <a
              href="https://www.imdb.com/name/nm3081444/"
              data-analytics-id="contact_imdb"
              data-analytics-handled="true"
              onClick={() => trackLinkClick('imdb', 'imdb.com/name/nm3081444')}
            >
              imdb.com/name/nm3081444
            </a>
            <br />
            <i className="fa fa-file-alt fa-fw"></i>
            <a
              href="/myke_dixon_resume.pdf"
              data-analytics-id="contact_resume"
              data-analytics-handled="true"
              onClick={() => trackLinkClick('resume', 'pdf_resume')}
            >
              PDF Resume
            </a>
            <br />
            <br />
          </p>
        </div>
      </div>
    </div>
  );
}
